var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-notification",style:(_vm.rightPosition)},[_c('div',[_vm._v(_vm._s(_vm.error))])])
}
var staticRenderFns = []

export { render, staticRenderFns }